import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Layout, { PageHero } from "@/components/Layout";
import api from "@/lib/api";

export default function NewsDetail() {
  const { id } = useParams();
  const [item, setItem] = useState(undefined);
  useEffect(() => { api.get(`/news/${id}`).then((r) => setItem(r.data)).catch(() => setItem(null)); }, [id]);

  if (item === undefined) return <Layout><div className="section"><div className="wrap">Loading...</div></div></Layout>;
  if (item === null) return (
    <Layout><div className="section"><div className="wrap">
      <p>Article not found.</p><Link to="/news" className="btn btn-outline">Back to News</Link>
    </div></div></Layout>
  );

  return (
    <Layout>
      <PageHero crumb={<><Link to="/">Home</Link> / <Link to="/news">News</Link> / {item.date}</>} title={item.title} />
      <section className="section">
        <div className="wrap" style={{ maxWidth: 780 }}>
          <div className="prose">
            <p style={{ whiteSpace: "pre-wrap", fontSize: 17 }}>{item.body || item.summary}</p>
            {item.link && (
              <a className="btn btn-outline" href={item.link} target="_blank" rel="noreferrer" style={{ marginTop: 10 }}>
                Read the source
              </a>
            )}
          </div>
          <div style={{ marginTop: 40 }}>
            <Link to="/news" className="btn btn-dark" data-testid="back-to-news">Back to all news</Link>
          </div>
        </div>
      </section>
    </Layout>
  );
}
